import dayjs from 'dayjs';

import { RecipientInfoDto } from 'app/models/api-dto.model';
import { AccessControlUserItem } from 'shared/access-control/accesscontrol-user-item';
import { SiteAsset } from 'shared/site';

export interface ReportCreatedBy {
    userId: string;
    userName: string;
}

export interface ReportForm {
    definition: ReportFormDefinition;
    period: ReportFormPeriod;
    recurrency: ReportFormRecurrency;
    publicationFrequency: ReportFormPublicationFrequency;
    sharing: ReportFormSharing;
    site: ReportFormSite;
}

export interface ReportFormSite {
    siteAsset: SiteAsset;
}

export interface ReportFormDefinition {
    id: string;
    name: string;
    description: string;
}

export interface ReportFormPeriod {
    dates: PeriodDates;
    selected: Options;
    reportPeriod?: number;
    fromDateOneOff?: string;
    toDateOneoff?: string;
}

export interface PeriodDates {
    startDate: dayjs.Dayjs;
    endDate: dayjs.Dayjs;
}

export interface PeriodDatesValidation {
    startDateAfterEndDate?: boolean;
    maxNumberOfDaysReached?: boolean;
    endDateBeforeLicenseFromDate?: boolean;
    startDateBeforeLicenseFromDate?: boolean;
}

export interface Period {
    label: string;
    option: Options;
}

export interface ReportFormRecurrency {
    recurrency: ReportType;
}

export interface ReportFormPublicationFrequency {
    startDate: dayjs.Dayjs;
    publicationFrequency: string;
}

export interface ReportFormSharing {
    users: AccessControlUserItem[];
}

export interface Report {
    guid: string;
    template: string;
    name: string;
    description: string;
    periodStartDate: dayjs.Dayjs;
    periodEndDate: dayjs.Dayjs;
    periodSelected: Options;
    recurrency: ReportType;
    startDate: dayjs.Dayjs;
    publicationFrequency: string;
    users: AccessControlUserItem[];
    shareList: RecipientInfoDto[];
    siteAssets: SiteAsset[];
}

export enum ReportType {
    OneOff = 0,
    Recurring = 1,
}

export enum ShareType {
    Off = 0,
    Shared = 1,
}

export enum ReportState {
    Active = 0,
    Draft = 1,
}

export enum ReportEditionState {
    Generated,
    Scheduled,

    // Http 422
    EditionStartDateAfterLicenseEndDate,
    EditionEndDateBeforeLicenseStartDate,
    EditionEndDateAfterLicenseEndDate,

    // Http 200
    ValidButEditionWillContainTruncatedData,

    Failed,
}

export enum Options {
    WEEK = 'week',
    LAST_WEEK = 'lastDayOfWeek',
    LAST_FULL_WEEK = 'lastFullWeek',
    LAST_SEVEN_DAYS = 'lastSevenDays',
    LAST_FOUR_WEEKS = 'lastFourWeeks',
    MONTH = 'month',
    LAST_MONTH = 'lastMonth',
    LAST_FULL_MONTH = 'lastFullMonth',
    LAST_THREE_MONTHS = 'lastThreeMonths',
    LAST_THIRTY_DAYS = 'lastThirtyDays',
    LAST_NINETY_DAYS = 'lastNinetyDays',
    QUARTER = 'quarter',
    LAST_FULL_QUARTER = 'lastFullQuarter',
    CUSTOM = 'custom',
    DAY = 'day',
}
